import React from 'react';
import { Autorenew, CheckRounded } from '@mui/icons-material';
import { Stack, styled, Typography } from '@mui/material';
import { useDeviceType } from 'contexts/ThemeContext/hooks/useDeviceType';
import { useThemeUtils } from 'contexts/ThemeContext/hooks/useThemeUtils';
import { AutoSaveStatus } from './types';

interface AuthSaveFlareProps {
  autoSaveStatus: AutoSaveStatus;
}

const AutoSaveContainer = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})<{ isMobile: boolean }>(({ isMobile, theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.25),
  minWidth: isMobile ? undefined : 100,
}));

const AutoSaveText = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[900],
}));

const SyncIcon = styled(Autorenew)(({ theme }) => ({
  fontSize: theme.spacing(1.5),
  animation: theme.animations.spin,
}));

export const AuthSaveFlare = ({ autoSaveStatus }: AuthSaveFlareProps) => {
  const { isMobile } = useDeviceType();
  const { theme } = useThemeUtils();

  if (autoSaveStatus === 'saved') {
    return (
      <AutoSaveContainer direction="row" isMobile={isMobile}>
        <CheckRounded
          sx={{
            fontSize: theme.spacing(1.5),
            color: 'green.800',
          }}
        />
        <AutoSaveText variant="caption">Autosaved</AutoSaveText>
      </AutoSaveContainer>
    );
  }

  return <AutoSaveContainer isMobile={isMobile} />;
};
